import React from 'react';
import { Card, Empty } from 'antd';
import { Pie } from '@ant-design/plots';
import { ResponsiveContainer } from 'recharts';

const ConnectedProtocolsChart = ({ data = [] }) => {
  const protocolData = data.map(d => ({
    name: d.protocolName,
    value: d.value,
    type: d.protocolName,
  }));

  const config = {
    data: protocolData,
    appendPadding: 10,
    angleField: 'value',
    colorField: 'type',
    radius: 0.8,
    autoFit: true,
    height: 400,
    pieStyle: { fillOpacity: 0.7 },
    label: { type: 'outer', content: '{name} {percentage}' },
    legend: { position: 'right' },
    color: ['#4E79A7','#F28E2B','#E15759','#76B7B2','#59A14F','#EDC948','#B07AA1','#FF9DA7']
  };

  return (
    <Card className="side-panel align-center" style={{ minHeight: '500px' }}>
      <div style={{ width: '100%', height: '100%', minHeight: '400px' }}>
        <ResponsiveContainer width="100%" height="100%">
          {protocolData.length ? (
            <div style={{ width: '100%', height: '100%' }}>
              <Pie {...config} />
            </div>
          ) : (
            <div
              style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Empty />
            </div>
          )}
        </ResponsiveContainer>
      </div>
    </Card>
  );
};

export default ConnectedProtocolsChart;